import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import customerService from './img/customer-service-man.svg'

export default function P2PIV() {
  const control = useAnimation();
  const [refIV, inViewIV] = useInView({
    rootMargin: '-100px 100px'
  });
  
  const leftVariant = {
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.5 }
    },
    hidden: {
      opacity: 0,
      x: -20,
      y: -20
    }
  }

  const rightVariant = {
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration: 0.5 }
    },
    hidden: {
      opacity: 0,
      x: 20,
      y: -20
    }
  }

  useEffect(() => {
    if(inViewIV) { control.start('visible') }
    if(!inViewIV) { control.start('hidden') }
  }, [control, {refIV, inViewIV}]);
  
  return (
    <>
      <div className="chooseUs-item">
        <h3 className="mView-header">24/7 Customer Support</h3>
        <motion.img
          src={customerService} alt="customer service" className="chooseUs-img"
          ref={refIV}
          variants={leftVariant}
          initial="hidden"
          animate={control}
        />
          <motion.div
            className="chooseUs-item-note"
            ref={refIV}
            variants={rightVariant}
            initial="hidden"
            animate={control}
          >
            <h3 className="mView-header-II">24/7 Customer Support</h3>
            <p>Our customer support team are available 24/7 to professionally resolve all concerns whilst leaving you with an unbeatable experience.</p>
          </motion.div>
        </div>
    </>
  )
}